module.exports = __webpack_public_path__ + "img/Step6m.29add4c2.png";